export const marketplace = {
  marketplaceSearchInputPlaceholderTitle: '검색',
  marketplaceDetailsCurtainCopyOptionTitle: '링크 복사',
  marketplaceDetailsCurtainFlagOptionTitle: '콘텐츠 신고',
  marketplaceDetailsCurtainCopiedAlertText: '링크가 복사되었습니다!',
  marketplaceDetailsFlagCurtainTitle: '신고',
  marketplaceReportedCurtainContent: '콘텐츠가 신고되었습니다',
  marketplaceAllItems: '모든 아이템',
  marketplaceWantToBuy: '{appname}에서 {item}을(를) 구매하고 싶습니다'
}
